import { mapApiDataToLegalNotices } from '@/lib/cms-mappers';

import type { FContentTemplateProps } from '@/components/templates/FContentTemplate.vue';

/**
 * Returns legal notices data fetched from CMS (Strapi)
 */
export async function useCmsLegalNotices(): UseCmsResponse<FContentTemplateProps> {
  const { t } = useI18n();
  const { data, error, pending, refresh } = await useStrapi('legal-notice');

  const mappedData = computed(() => mapApiDataToLegalNotices(data.value?.data));
  const i18nMappedData = computed<FContentTemplateProps>(() => ({
    ...mappedData.value,
    title: t('legal__title'),
  }));

  return { data: i18nMappedData, error, pending, refresh };
}
